import { render, staticRenderFns } from "./annoation.vue?vue&type=template&id=d7f6f9ec&scoped=true&"
import script from "./annoation.vue?vue&type=script&lang=js&"
export * from "./annoation.vue?vue&type=script&lang=js&"
import style0 from "./annoation.vue?vue&type=style&index=0&id=d7f6f9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f6f9ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
